module.exports = __webpack_public_path__ + "static/media/editIcon.d0d2238a.svg";